import React, { useEffect, useState } from 'react';
// import './Ticketsystem.css';

function Ticketsystem() {
  const [employeeIds, setEmployeeIds] = useState([]);
  const [formData, setFormData] = useState({
    empId: '',
    empName: '',
    email: '',
    issueType: 'leave',
    priority: 'high',
    ticketDescription: ''
  });

  // Fetch employee IDs on component mount
  useEffect(() => {
    fetch('https://cleezoclass.com:8443/api/get-empIds')  // Your backend URL here
      .then(response => response.json())
      .then(data => {
        setEmployeeIds(data.empIds);
      })
      .catch(error => {
        console.error('Error fetching employee IDs:', error);
        alert('Error fetching employee data');
      });
  }, []);

  // Fetch employee details when empId changes
  const handleEmpIdChange = (event) => {
    const empId = event.target.value;
    setFormData({ ...formData, empId });

    if (empId) {
      fetch(`https://cleezoclass.com:8443/api/get-employee-details/${empId}`)  // Your backend URL here
        .then(response => response.json())
        .then(data => {
          if (data.message) {
            alert(data.message); // Show error if employee not found
          } else {
            setFormData(prevData => ({
              ...prevData,
              empName: data.empName,
              email: data.email
            }));
          }
        })
        .catch(error => {
          console.error('Error fetching employee details:', error);
          alert('Error fetching employee details');
        });
    }
  };

  // Handle form input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();

    fetch('https://cleezoclass.com:8443/api/create-ticket', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.message === 'Ticket created successfully') {
          alert('Ticket created successfully! Ticket ID: ' + data.ticketId);
          setFormData({
            empId: '',
            empName: '',
            email: '',
            issueType: 'leave',
            priority: 'high',
            ticketDescription: ''
          });
        } else {
          alert('Error creating ticket');
        }
      })
      .catch(error => {
        console.error('Error creating ticket:', error);
        alert('Error creating ticket.');
      });
  };

  return (
    <div className="ticket-system-container">


      <section className="ticket-form">
        <header>
          <h1>Employee Ticketing System</h1>
        </header>
        <h2>Create New Ticket</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="empId">Employee ID</label>
            <select id="empId" name="empId" value={formData.empId} onChange={handleEmpIdChange} required>
              <option value="">Select Employee ID</option>
              {employeeIds.map(empId => (
                <option key={empId} value={empId}>{empId}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="empName">Employee Name</label>
            <input type="text" id="empName" name="empName" value={formData.empName} placeholder="Employee Name" readOnly />
          </div>

          <div className="form-group">
            <label htmlFor="email">Employee Email</label>
            <input type="email" id="email" name="email" value={formData.email} placeholder="Employee Email" readOnly />
          </div>

          <div className="form-group">
            <label htmlFor="issueType">Issue Type</label>
            <select id="issueType" name="issueType" value={formData.issueType} onChange={handleChange} required>
              <option value="leave">Leave Request</option>
              <option value="project">Project Issue</option>
              <option value="technical">Technical Issue</option>
              <option value="billing">Billing Issue</option>
              <option value="general">General Inquiry</option>
              <option value="complaint">Employee Complaint</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="priority">Priority</label>
            <select id="priority" name="priority" value={formData.priority} onChange={handleChange} required>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="ticketDescription">Ticket Description</label>
            <textarea id="ticketDescription" name="ticketDescription" value={formData.ticketDescription} onChange={handleChange} placeholder="Describe the issue in detail" required></textarea>
          </div>

          <button type="submit">Create Ticket</button>
        </form>
      </section>
    </div>
  );
}

export default Ticketsystem;
